import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteArquivosCliente(id: string) {
  return useMutation(
    `/v1/cliente/arquivos/deletar`,
    (arquivoId: string) =>
      http.delete(
        `/v1/cliente/${id}/arquivos/${arquivoId}`
      ),
    { retry: false }
  );
}

export default useDeleteArquivosCliente;
